/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

        /* list or grid item*/
        $(".view i").click(function(){
    
          $('.grid').removeClass('grid-view list-view').addClass($(this).data('view'));
    
        })
        $(".view i").click(function(){
    
          $(this).addClass('selected').siblings().removeClass('selected');
    
        })

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
